var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { createPlugin } from '../../../../Fct/createPlugin';
import { FctAddress, FctBytesList, FctString, FctValue } from '../../../../Fct/generics';
import { exchangeRouterContracts, TOKENS } from '../constants';
import { GMXHelper } from '../helpers/GMXHelper';
import { TradeMode, TradeType } from '../types';
var gmxHelper = new GMXHelper({ chainId: '42161' });
export var IncreasePositionMulticall = createPlugin({
    protocol: 'GMX',
    type: 'ACTION',
    method: 'multicall',
    name: 'increasePositionMulticall',
    supportedContracts: exchangeRouterContracts,
    getParams: function (_a) {
        var _b;
        var chainId = _a.chainId;
        return ({
            input: {
                to: new FctAddress({}),
                value: new FctValue({ readonly: true }),
                market: new FctAddress({ mode: 'INPUT' }),
                payToken: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: (_b = TOKENS[Number(chainId)]) === null || _b === void 0 ? void 0 : _b.filter(function (token) { return !token.isSynthetic; }),
                }),
                payAmount: new FctValue({ mode: 'INPUT' }),
                getToken: new FctAddress({
                    destination: 'erc20',
                    mode: 'INPUT',
                    options: TOKENS[Number(chainId)],
                    readonly: true,
                }),
                getAmount: new FctValue({ mode: 'INPUT' }),
                collateralIn: new FctAddress({ mode: 'INPUT' }),
                tradeType: new FctString({
                    mode: 'INPUT',
                    options: [
                        { value: TradeType.Long, name: 'Long' },
                        { value: TradeType.Short, name: 'Short' },
                    ],
                }),
                methodParams: {
                    data: new FctBytesList({ readonly: true }),
                },
            },
            output: {
                results: new FctBytesList({}),
            },
        });
    },
    setValuesAsync: function (_a) {
        var chainId = _a.chainId, account = _a.account, input = _a.input, provider = _a.provider;
        return __awaiter(void 0, void 0, void 0, function () {
            var tokensData, marketsInfo, allMarkets, bestMarkets_1, marketsAddressesSet;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        gmxHelper.setLibrary({ chainId: chainId, provider: provider, account: account });
                        return [4 /*yield*/, gmxHelper.getTokensData()];
                    case 1:
                        tokensData = _b.sent();
                        return [4 /*yield*/, gmxHelper.getMarketsInfo()];
                    case 2:
                        marketsInfo = _b.sent();
                        if (tokensData.tokensData && tokensData.pricesUpdatedAt) {
                            gmxHelper.tokensData = tokensData;
                        }
                        gmxHelper.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
                        if (!(marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData))
                            return [2 /*return*/];
                        if (input) {
                            allMarkets = Object.keys(marketsInfo.marketsInfoData).filter(function (key) { var _a, _b; return !((_a = marketsInfo.marketsInfoData[key]) === null || _a === void 0 ? void 0 : _a.isDisabled) && !((_b = marketsInfo.marketsInfoData[key]) === null || _b === void 0 ? void 0 : _b.isSpotOnly); });
                            bestMarkets_1 = [];
                            marketsAddressesSet = new Set();
                            allMarkets.forEach(function (key) {
                                //const { indexToken } = marketsInfo.marketsInfoData[key]
                                // const availableMarkets = allMarkets.filter((market) =>
                                //   isMarketIndexToken(marketsInfo.marketsInfoData[market], indexToken.value)
                                // )
                                // if (marketsAddressesSet.has(availableMarkets[0])) return
                                // marketsAddressesSet.add(availableMarkets[0])
                                var _a = marketsInfo.marketsInfoData[key], indexToken = _a.indexToken, shortToken = _a.shortToken, longToken = _a.longToken, marketTokenAddress = _a.marketTokenAddress;
                                bestMarkets_1.push({
                                    value: key,
                                    logoURI: indexToken.logoURI,
                                    name: "".concat(indexToken.symbol, " / USD, Pool: ").concat(longToken.symbol, "-").concat(shortToken.symbol),
                                    marketAddress: marketTokenAddress,
                                    indexToken: indexToken.symbol,
                                    longToken: longToken.symbol,
                                    shortToken: shortToken.symbol,
                                });
                            });
                            input.market.options = bestMarkets_1;
                        }
                        return [2 /*return*/];
                }
            });
        });
    },
    calculateValuesOnUserInput: function (_a) {
        var chainId = _a.chainId, input = _a.input, account = _a.account, provider = _a.provider;
        if (gmxHelper.chainId !== Number(chainId) || gmxHelper.account !== account) {
            gmxHelper.setLibrary({ chainId: chainId, provider: provider, account: account });
        }
        var getIncreasePositionParams = function () { return __awaiter(void 0, void 0, void 0, function () {
            var payToken, market, payAmount, tradeType, collateralIn, marketsInfo, marketData, getToken, params, tradeTypeValue, increasePositionParams;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        payToken = input.payToken, market = input.market, payAmount = input.payAmount, tradeType = input.tradeType, collateralIn = input.collateralIn;
                        if (!market.value)
                            return [2 /*return*/];
                        if (typeof market.value !== 'string')
                            return [2 /*return*/];
                        if (!!gmxHelper.marketsInfo) return [3 /*break*/, 2];
                        return [4 /*yield*/, gmxHelper.getMarketsInfo()];
                    case 1:
                        marketsInfo = _a.sent();
                        gmxHelper.marketsInfo = marketsInfo === null || marketsInfo === void 0 ? void 0 : marketsInfo.marketsInfoData;
                        _a.label = 2;
                    case 2:
                        marketData = gmxHelper.marketsInfo[market.value];
                        getToken = marketData.indexTokenAddress;
                        params = {
                            params: {
                                getToken: getToken,
                            },
                            error: undefined,
                        };
                        collateralIn.options = [marketData.longToken, marketData.shortToken];
                        if (!input.collateralIn.value ||
                            ![marketData.longToken.value, marketData.shortToken.value].includes(input.collateralIn.value)) {
                            collateralIn.value = marketData.longToken.value;
                        }
                        if (!payToken.value)
                            return [2 /*return*/, params];
                        if (!getToken)
                            return [2 /*return*/, params];
                        if (!payAmount.value)
                            return [2 /*return*/, params];
                        if (!tradeType.value)
                            return [2 /*return*/, params];
                        if (typeof collateralIn.value !== 'string' ||
                            typeof payToken.value !== 'string' ||
                            typeof payAmount.value !== 'string' ||
                            typeof tradeType.value !== 'string') {
                            console.error("wrong param type");
                            return [2 /*return*/, params];
                        }
                        tradeTypeValue = tradeType.value;
                        return [4 /*yield*/, gmxHelper.getIncreasePositionParams({
                                fromTokenAddress: payToken.value,
                                toTokenAddress: getToken,
                                fromTokenAmount: payAmount.value,
                                toTokenAmount: '0',
                                tradeType: tradeTypeValue,
                                tradeMode: TradeMode.Market,
                                marketAddress: market.value,
                                collateralInToken: collateralIn.value || marketData.longToken.value,
                            })];
                    case 3:
                        increasePositionParams = _a.sent();
                        if (!increasePositionParams) {
                            return [2 /*return*/, {
                                    params: {
                                        value: undefined,
                                        getToken: undefined,
                                        methodParams: {
                                            data: undefined,
                                        },
                                    },
                                    error: 'get increase amount params error',
                                }];
                        }
                        return [2 /*return*/, {
                                params: {
                                    value: increasePositionParams.totalWntAmount.toString(),
                                    getToken: params.params.getToken,
                                    methodParams: {
                                        data: increasePositionParams.encodedPayload,
                                    },
                                },
                                error: undefined,
                            }];
                }
            });
        }); };
        return {
            get: getIncreasePositionParams,
            depParamKeys: ['payToken', 'payAmount', 'getToken', 'market', 'tradeType', 'collateralIn'],
        };
    },
});
